import React, { Component } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Add from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import { Field, FieldArray } from 'redux-form';
import { renderCriteriaOptions, renderMultiSelect } from '../FormFields/reduxFormRenderers';
import { connect } from 'react-redux';

class DomainAffiliate extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderDomainAffiliates = ({ fields, name, isLoading }) => {
    return (
      <div>
        {fields.map((fieldName, index) => (
          <div key={index}>
            <Card sx={{ mb: 2 }}>
              <CardHeader
                title={
                  <Tooltip title='Remove Domain-specific Affiliates'>
                    <IconButton
                      color='error'
                      type='button'
                      aria-label='Remove Domain-specific Affiliates'
                      onClick={() => fields.remove(index)}
                    >
                      <Close fontSize='small' />
                    </IconButton>
                  </Tooltip>
                }
                slotProps={{ title: { component: 'div' } }}
              />
              <CardContent>
                <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                  Domains
                </FormLabel>
                <Field
                  name={`${fieldName}.domains`}
                  id={`${fieldName}.domains`}
                  component={renderMultiSelect}
                  type='select'
                  textField={(item) =>
                    item.name && item.name.startsWith('#') ? `${item.id}` : `${item.id}: ${item.name}`
                  }
                  dataKey='name'
                  data={this.props.domains}
                  busy={isLoading}
                  groupBy={(item) => (item.name.startsWith('#') ? 0 : 1)}
                  renderListGroup={({ group }) => (group === 0 ? <span>Tags</span> : <span>Domains</span>)}
                />
                {fields.get(index).domains?.length !== 0 && (
                  <Grid container spacing={2} sx={{ mt: 1, alignItems: 'start' }}>
                    <Grid size={{ xs: 12, lg: 3 }}>
                      <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                        Include/Exclude
                      </FormLabel>
                      <Field
                        name={`${fieldName}.includeExcludeAction`}
                        type='select'
                        component={renderCriteriaOptions}
                      />
                    </Grid>
                    <Grid size='grow'>
                      <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                        Affiliate
                      </FormLabel>
                      <Field
                        id={`${fieldName}.affiliates`}
                        name={`${fieldName}.affiliates`}
                        component={renderMultiSelect}
                        type='select'
                        textField={(item) =>
                          item.name && item.name.startsWith('#') ? `${item.id}` : `${item.id}: ${item.name}`
                        }
                        dataKey='name'
                        data={this.props.affiliates}
                        busy={this.props.isLoading}
                        groupBy={(item) => (item.name.startsWith('#') ? 0 : 1)}
                        renderListGroup={({ group }) => (group === 0 ? <span>Tags</span> : <span>Affiliates</span>)}
                      />
                    </Grid>
                  </Grid>
                )}
              </CardContent>
            </Card>
          </div>
        ))}
        <Box>
          <Tooltip title='Add Domain-specific Affiliates'>
            <IconButton
              color='success'
              aria-label='Add Domain-specific Affiliates'
              onClick={() => fields.push({ domains: [], affiliates: [], includeExcludeAction: null })}
            >
              <Add />
            </IconButton>
          </Tooltip>
        </Box>
      </div>
    );
  };

  componentDidMount() {}

  render() {
    return (
      <FieldArray
        name='domainAffiliateConfiguration.domainAffiliateEntries'
        component={this.renderDomainAffiliates}
        isLoading={this.props.isLoading}
      />
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {})(DomainAffiliate);
